import { request } from "."

export const supervisorApi = {
  getAllReports() {
    return request("/api/supervisor-reports")
  }
}